type ExpressionType = 'alpha' | 'alphaNum' | 'decimal' | 'email' | 'integer' | 'numeric' | 'url';

export const regex = (type: ExpressionType | string | RegExp, message = 'Not a valid value') => (value: any): boolean | string => {
    if (value == null || value == '') {
        return true;
    }

    let expression;
    switch (type) {
        case 'alpha':
            expression = /^[a-zA-Z]*$/;
            message = 'Must contain only alpha characters';
            break;
        case 'alphaNum':
            expression = /^[a-zA-Z0-9]*$/;
            message = 'Must contain only alpha and numeric characters';
            break;
        case 'decimal':
            expression = /^[-]?\d*(\.\d+)?$/;
            message = 'Must contain only decimal values';
            break;
        case 'email':
            expression = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
            message = 'Invalid email address.';
            break;
        case 'integer':
            expression = /(^[0-9]*$)|(^-[0-9]+$)/;
            message = 'Must contain only integer values';
            break;
        case 'numeric':
            expression = /^[0-9]*$/;
            message = 'Must contain only numeric values';
            break;
        case 'url':
            //expression = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
            // made local ips valid also
            expression = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?((?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
            message = 'Must contain a valid url';
            break;
        default:
            expression = new RegExp(type);
    }

    if (!expression.test(value)) {
        return message;
    }

    return true;
};
